import * as localStorageHelper from '@/store/localStorageHelper'
import {
  searchPotentialSponsors,
  selectSponsor,
  submitForm
} from '@/services/api'

const STATE_LOCAL_STORAGE_KEY = 'storeState'
const DEFAULT_CONTACT_INFO = {
  firstname: '',
  lastname: '',
  country: '',
  postalCode: '',
  discover: '',
  email: '',
  phone: '',
  socialNetwork: '',
  interests: [],
  hasBeenVdi: false
}

let state = {
  prospectId: undefined,
  contactInfo: { ...DEFAULT_CONTACT_INFO },
  potentialSponsors: [],
  selectedSponsor: undefined,
  isAlreadyAssigned: false
}

export const loadStateFromLocalStorage = () => {
  const stateFromLocalStorage = localStorageHelper.getItem(
    STATE_LOCAL_STORAGE_KEY
  )
  if (stateFromLocalStorage) {
    try {
      state = JSON.parse(stateFromLocalStorage)
    } catch (error) {
      console.error(error)
    }
  }
}

const _saveStateInLocalStorage = () => {
  localStorageHelper.setItem(STATE_LOCAL_STORAGE_KEY, JSON.stringify(state))
}

export const submitProspectForm = async (
  newContactInfo,
  routerRedirectionCallback
) => {
  const { prospectId, isAlreadyAssigned } = await submitForm(newContactInfo)
  const hasChangedCountryOrPostalCode =
    (newContactInfo.country &&
      newContactInfo.country !== state.contactInfo.country) ||
    (newContactInfo.postalCode &&
      newContactInfo.postalCode !== state.contactInfo.postalCode)

  state.prospectId = prospectId
  state.contactInfo = newContactInfo
  state.isAlreadyAssigned = isAlreadyAssigned

  if (isAlreadyAssigned) {
    _saveStateInLocalStorage()
    await routerRedirectionCallback('stylistConfirmation')
  } else {
    try {
      if (hasChangedCountryOrPostalCode) {
        const potentialSponsors = await searchPotentialSponsors(
          state.prospectId
        )
        state.potentialSponsors = potentialSponsors
      }
    } catch (error) {
      console.error(error)
    } finally {
      _saveStateInLocalStorage()
      await routerRedirectionCallback('stylistSelection')
    }
  }
}

export const makeSponsorSelection = async (
  sponsor,
  routerRedirectionCallback
) => {
  try {
    const prospectId = state.prospectId

    const selectedSponsor = await selectSponsor(prospectId, sponsor.customerId)

    state.selectedSponsor = selectedSponsor
    _saveStateInLocalStorage()
    if (selectedSponsor) {
      await routerRedirectionCallback('stylistConfirmation')
    }
  } catch (error) {
    console.error(error)
  }
}

loadStateFromLocalStorage()

export const getContactInfo = () => {
  return { ...state.contactInfo }
}

export const getPossibleSponsors = () => {
  let sponsors = []

  if (state.potentialSponsors) {
    sponsors = [...state.potentialSponsors]
  }

  return sponsors
}

export const getAssignedStatus = () => {
  return state.isAlreadyAssigned
}

export const getSelectedSponsor = () => {
  return { ...state.selectedSponsor }
}
